import { useSyncExternalStore } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { tokenStorage } from '@/services/tokenStorage';

/**
 * The live tree requires a session; `/test` does not (it has no real data).
 * Subscribed to the token store, so ending the session anywhere — sign-out,
 * a refresh that failed, another tab — leaves the tree at once.
 */
export function RequireAuth() {
  const location = useLocation();
  const hasSession = useSyncExternalStore(tokenStorage.subscribe, tokenStorage.hasSession);
  if (!hasSession) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
